/**
 * Store hours gate.
 *
 * Single source of truth for "are we accepting orders right now".
 * Blocks every checkout path in the theme, not just the order-menu side cart.
 *
 * EDIT THE HOURS HERE — nowhere else.
 */
(function () {
  'use strict';

  // Orders are CLOSED from OPEN_END until OPEN_START (local Sofia time).
  var CLOSE_AT = { hour: 21, minute: 30 }; // last orders accepted up to 21:29
  var OPEN_AT = { hour: 11, minute: 0 };
  var TIMEZONE = 'Europe/Sofia';
  var CLOSED_MESSAGE = 'Поръчките са затворени, защото не работим. Отваряме 11 сутрин.';

  var CLOSED_START_MIN = CLOSE_AT.hour * 60 + CLOSE_AT.minute;
  var CLOSED_END_MIN = OPEN_AT.hour * 60 + OPEN_AT.minute;

  var formatter = null;
  try {
    formatter = new Intl.DateTimeFormat('en-GB', {
      timeZone: TIMEZONE,
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
  } catch (e) {
    formatter = null;
  }

  /** Minutes since midnight in the shop's timezone, or -1 if unavailable. */
  function minutesNow() {
    if (!formatter) return -1;
    try {
      var parts = formatter.formatToParts(new Date());
      var h = Number((parts.find(function (p) { return p.type === 'hour'; }) || {}).value || 0);
      var m = Number((parts.find(function (p) { return p.type === 'minute'; }) || {}).value || 0);
      return h * 60 + m;
    } catch (e) {
      return -1;
    }
  }

  /**
   * Evaluated fresh on every call — never cache the result.
   * Fails open (returns false) if the timezone can't be read, so a broken
   * browser can still order rather than being locked out all day.
   */
  function isClosed() {
    var mins = minutesNow();
    if (mins === -1) return false;
    if (CLOSED_START_MIN > CLOSED_END_MIN) {
      // Window wraps past midnight (the normal case: 21:30 → 11:00).
      return mins >= CLOSED_START_MIN || mins < CLOSED_END_MIN;
    }
    return mins >= CLOSED_START_MIN && mins < CLOSED_END_MIN;
  }

  var StoreHours = {
    isClosed: isClosed,
    message: CLOSED_MESSAGE,
    closesAt: CLOSED_START_MIN,
    opensAt: CLOSED_END_MIN,
  };
  window.StoreHours = StoreHours;

  // --- Reflect state in the DOM so CSS can hide/disable things -------------

  function paint() {
    var closed = isClosed();
    document.documentElement.classList.toggle('store-closed', closed);
    document.documentElement.classList.toggle('store-open', !closed);

    // Native checkout buttons (cart page + cart drawer).
    var buttons = document.querySelectorAll(
      'button[name="checkout"], #checkout, [data-checkout-trigger]'
    );
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      if (closed) {
        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('aria-disabled', 'true');
        addNotice(btn);
      } else if (btn.hasAttribute('aria-disabled')) {
        // Only re-enable buttons we disabled — leave the theme's own
        // empty-cart disabling alone.
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-disabled');
        removeNotice(btn);
      }
    }
    return closed;
  }

  function addNotice(btn) {
    var parent = btn.parentElement;
    if (!parent || parent.querySelector('.store-closed-notice')) return;
    // The order-menu side cart renders its own message already.
    if (parent.querySelector('[data-closed-msg]')) return;
    var el = document.createElement('div');
    el.className = 'store-closed-notice';
    el.setAttribute('role', 'status');
    el.textContent = CLOSED_MESSAGE;
    parent.insertBefore(el, btn);
  }

  function removeNotice(btn) {
    var parent = btn.parentElement;
    if (!parent) return;
    var el = parent.querySelector('.store-closed-notice');
    if (el) el.remove();
  }

  // --- Hard block on every checkout path ----------------------------------

  function block(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    paint();
    window.alert(CLOSED_MESSAGE);
  }

  // Capture phase, so this runs before any theme or app handler.
  document.addEventListener(
    'click',
    function (event) {
      if (!isClosed()) return;
      var target = event.target;
      if (!target || !target.closest) return;
      var hit = target.closest(
        'button[name="checkout"], #checkout, [data-checkout-trigger], [data-note-submit], a[href*="/checkout"]'
      );
      if (hit) block(event);
    },
    true
  );

  // Cart forms submitted by other means (Enter key, app scripts).
  document.addEventListener(
    'submit',
    function (event) {
      if (!isClosed()) return;
      var form = event.target;
      if (!form || !form.action) return;
      if (/\/(checkout|cart)\b/.test(String(form.action))) block(event);
    },
    true
  );

  // --- Keep it live -------------------------------------------------------

  paint();
  document.addEventListener('DOMContentLoaded', paint);
  setInterval(paint, 30 * 1000);
  // A page restored from bfcache or refocused after hours must re-evaluate.
  window.addEventListener('pageshow', paint);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) paint();
  });
})();
